import { v4 as uuidv4 } from 'uuid'
import { stoppagesAjax } from '../ajax/StoppagesAjax'
import { store } from '../state/store'
import type { ActionResponse } from '../DTOs/Common/ErrorResponse'
import type { StoppageDto } from '../DTOs/Stoppage/StoppageDto'
import { computeShiftId } from './computeShiftId'
import { enqueue } from './queueOps'

function currentShiftId(): number {
  const { selectedDate, selectedShift } = store.getState().shift
  return computeShiftId(selectedDate, selectedShift)
}

function serialize(obj: unknown): unknown {
  return JSON.parse(JSON.stringify(obj))
}

export const stoppagesMutations = {
  async addStoppage(dto: StoppageDto) {
    if (navigator.onLine) return stoppagesAjax.addStoppage(dto)
    const tempId = uuidv4()
    await enqueue({
      entity: 'stoppage',
      operation: 'create',
      shiftId: currentShiftId(),
      tempId,
      data: serialize(dto),
    })
    return { success: true, data: { ...dto, stoppageId: -(Date.now()) } as StoppageDto | null }
  },

  async updateStoppage(dto: StoppageDto) {
    if (navigator.onLine) return stoppagesAjax.updateStoppage(dto)
    // Note: strip nav properties - server validates them but they cause 400s when owner/etc. are null
    const { plant: _p, stoppageType: _st, stoppageSubType: _sst, location: _l, ...fields } = dto
    await enqueue({
      entity: 'stoppage',
      operation: 'update',
      shiftId: currentShiftId(),
      entityId: dto.stoppageId,
      rowVersion: dto.rowVersion,
      data: serialize(fields),
    })
    return { success: true, data: dto as StoppageDto | null }
  },

  async deleteStoppage(id: number, rowVersion?: string) {
    if (navigator.onLine) return stoppagesAjax.deleteStoppage(id)
    await enqueue({
      entity: 'stoppage',
      operation: 'delete',
      shiftId: currentShiftId(),
      entityId: id,
      rowVersion,
    })
    return { success: true, data: null as null }
  },
}
